import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectLang,
  Translate,
} from "../../../../app/store/reducers/main/mainReducer";
import AdvanceTableWrapper from "../../../common/advance-table/AdvanceTableWrapper";
import {
    changeDesktopAppVersionsFilterOptionsAsync,
    selectDesktopAppVersions,
    selectDesktopAppVersionsCount,
    selectDesktopAppVersionsFilterOptions,
    loadDesktopAppVersionsAsync,
    loadDesktopAppVersionsCountAsync,
    setMode,  
    selectMode,
    
} from "../../../../app/store/reducers/desktop-app/desktopAppReducer";


import {
  Badge,
  Card,
  Col,
  Row,
  Button,
  ButtonGroup,
} from "react-bootstrap";
import AdvanceTable from "../../../common/advance-table/AdvanceTable";
import AdvanceTableFooter from "../../../common/advance-table/AdvanceTableFooter";
import AdvanceTableCustomPagination from "../../../common/advance-table/AdvanceTableCustomPagination";
import DesktopAppVersionActivationSwitcher from "../actions/DesktopAppVersionActivationSwitcher";
import DeleteDesktopAppVersion from "../actions/DeleteDesktopAppVersion";
import AddDesktopAppNewVersion from "../AddDesktopAppNewVersion";
import { GetOsLabel } from "../../../../enum/DesktopApp";

const DesktopAppVersionsDatatable = () => {
  const filter = useSelector(selectDesktopAppVersionsFilterOptions);
  const desktopAppVersions = useSelector(selectDesktopAppVersions);
  const count = useSelector(selectDesktopAppVersionsCount);
  const lang = useSelector(selectLang);
  const dispatch = useDispatch();
  const t = Translate;
  const mode = useSelector(selectMode);


  const columns = [
    {
      Header: "#",
      id: "row",
      maxWidth: 50,
      filterable: false,
      Cell: ({ row }) => row.index + 1,
    },
    {
      accessor: "version",
      Header: t(lang, "admin.desktop_app_versions.datatable.column.version"),
      Cell: ({ row: { original } }) => original.version,
    },
    {
      accessor: "os_type",
      Header: t(lang, "admin.desktop_app_versions.datatable.column.os_type"),
      Cell: ({ row: { original } }) => GetOsLabel(original.os_type),
    },
    ...(mode === "new"? [
      {
        accessor: "type",
        Header: t(lang, "admin.desktop_app_versions.add_desktop_app_version_modal.field.type.title"),
        Cell: ({ row: { original } }) => {
          return original.type ? original.type : null;
        }
      },
    ]
    : []),
    {
      accessor: "is_active",
      Header: t(lang, "admin.desktop_app_versions.datatable.column.is_active"),
      Cell: ({ row: { original } }) =>
        original.is_active ? (
          <Badge bg="success">
            {t(
              lang,
              "admin.desktop_app_versions.datatable.row.is_active.active"
            )}
          </Badge>
        ) : (
          <Badge bg="secondary">
            {t(
              lang,
              "admin.desktop_app_versions.datatable.row.is_active.not_active"
            )}
          </Badge>
        ),
    },
    ...(mode === "new"? [
          {
            accessor: "is_critical",
            Header: t(
              lang,
              "admin.desktop_app_versions.add_desktop_app_version.field.is_critical.title"
            ),
            Cell: ({ row: { original } }) =>
              original.is_critical ? (
                <Badge bg="success">
                  {t(
                    lang,
                    "admin.desktop_app_versions.datatable.row.is_active.active"
                  )}
                </Badge>
              ) : (
                <Badge bg="secondary">
                  {t(
                    lang,
                    "admin.desktop_app_versions.datatable.row.is_active.not_active"
                  )}
                </Badge>
              ),
            show: desktopAppVersions?.some((item) => item.is_critical),
          },
        ]
    : []),
    {
      accessor: "none",
      cellProps: { className: "text-end" },
      Cell: ({ row: { original } }) => (
        <>
          <DesktopAppVersionActivationSwitcher
            version={original}
            className="cursor-pointer d-inline-block mx-2"
          />
          <DeleteDesktopAppVersion
            id={original.id}
            className="ms-2 text-danger cursor-pointer"
          />
        </>
      ),
    },
  ];

  

  const onPageChange = (page) => {
    const newFilter = { ...filter, page };
    dispatch(changeDesktopAppVersionsFilterOptionsAsync(newFilter));
    dispatch(loadDesktopAppVersionsAsync(newFilter));
    dispatch(loadDesktopAppVersionsCountAsync(newFilter));
  };
  
  const onLimitChange = (limit) => {
    const newFilter = { ...filter, limit, page: 1 };
    dispatch(changeDesktopAppVersionsFilterOptionsAsync(newFilter));
    dispatch(loadDesktopAppVersionsAsync(newFilter));
    dispatch(loadDesktopAppVersionsCountAsync(newFilter));
  };
  

  return (
    <AdvanceTableWrapper columns={columns} data={desktopAppVersions} pagination perPage={10}>
      <Card>
        <Card.Header as={Row}>
          <Row className="align-items-center w-100">
            <Col xs={6}>
              <h4>{t(lang, "admin.desktop_app_versions.title")}</h4>
            </Col>
            <Col xs="auto" className="ms-auto">
              <AddDesktopAppNewVersion size="sm" />
            </Col>
          </Row>

          {/* Buttonlar */}
          <Row className="mt-3">
            <Col>
            <ButtonGroup style={{ width: "100%", gap: "2rem" }} size="lg" aria-label="Large button group">
              <Button
                variant="outline-primary"
                active={mode === "old"}
                onClick={() => {
                  dispatch(setMode("old"));
                  dispatch(loadDesktopAppVersionsAsync(filter));
                  dispatch(loadDesktopAppVersionsCountAsync(filter));
                }}
              >
                {t(lang, "admin.desktop_app_versions.add_desktop_app_version.hippo_pos")}
              </Button>

              <Button
                variant="outline-primary"
                active={mode === "new"}
                onClick={() => {
                  dispatch(setMode("new"));
                  dispatch(loadDesktopAppVersionsAsync(filter));
                  dispatch(loadDesktopAppVersionsCountAsync(filter));
                }}
              >
                {t(lang, "admin.desktop_app_versions.add_desktop_app_version.local_pos")}
              </Button>
            </ButtonGroup>


            </Col>
          </Row>
        </Card.Header>

        <Card.Body>
          <AdvanceTable
            table
            headerClassName="bg-200 text-900 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap"
            tableProps={{
              size: "sm",
              striped: true,
              className: "fs--1 mb-0 overflow-hidden",
            }}
          />
        </Card.Body>

        <Card.Footer>
          <AdvanceTableFooter table />
          <AdvanceTableCustomPagination
            count={count}
            limit={filter.limit}
            page={filter.page}
            onLimitChange={onLimitChange}
            onPageChange={onPageChange}
          />
        </Card.Footer>
      </Card>
    </AdvanceTableWrapper>
  );
};

export default DesktopAppVersionsDatatable;
